export class MultiselectVM {
    item_id: number = 0;
    item_text: string = "";
}
